export const STORY_RIBBONS_HEIGHT = 92

export const STORY_RIBBON_HEIGHT_CSS_VAR = 'var(--view-story-ribbon-height)'

export const STORY_RIBBON_TRANSITION_MS = 250

export const DEFAULT_TRANSITION_MS = 250

export const STORY_VIDEO_COMPRESSION_HEIGHT = 480

export const CAN_CREATE_STORY_STORY_COUNT = 16
